/**
 * Biometria nativa — T-BIO-01 / T-PLAT-09
 *
 * Plugin escolhido: `@aparajita/capacitor-biometric-auth` ~8.0.2
 * - Compatível com Capacitor 6 no projeto Synap (peer `@capacitor/core` ^6).
 * - `checkBiometry()` + `authenticate()` com `allowDeviceCredential` (PIN/padrão Android).
 * - Alternativa `@capgo/capacitor-native-biometric` descartada: foco em credenciais no Keystore,
 *   menos alinhado ao gate de desbloqueio sem armazenar segredos no app.
 *
 * Web: `isBiometricAvailable` → false (WebAuthn fica para fase futura).
 */
import { platform } from '@/shared/lib/platform/platform'

/** Indica se biometria (ou credencial do dispositivo) está disponível para uso. */
export const isBiometricAvailable = async (): Promise<boolean> => {
  if (!platform.isNative()) {
    return false
  }
  const { BiometricAuth, BiometryType } = await import('@aparajita/capacitor-biometric-auth')
  const result = await BiometricAuth.checkBiometry()
  if (result.isAvailable && result.biometryType !== BiometryType.none) {
    return true
  }
  return result.deviceIsSecure === true
}

/** Solicita autenticação biométrica ou credencial do dispositivo. */
export const authenticateBiometric = async (reason: string): Promise<boolean> => {
  if (!platform.isNative()) {
    return false
  }
  const { BiometricAuth, BiometryError, BiometryErrorType } = await import(
    '@aparajita/capacitor-biometric-auth'
  )
  try {
    await BiometricAuth.authenticate({
      reason,
      allowDeviceCredential: true,
      cancelTitle: 'Cancelar',
      iosFallbackTitle: 'Usar senha',
      androidTitle: 'Autenticação Synap',
      androidSubtitle: reason,
    })
    return true
  } catch (error) {
    if (error instanceof BiometryError && error.code === BiometryErrorType.userCancel) {
      return false
    }
    return false
  }
}
